{
  "Parametre": "Parametre",
  "parametre": {
    "E-Mail Görünen mail adres": "E-Mail Görünen mail adres",
    "Firma Adı": "Firma Adı",
    "Host": "Host",
    "Mail": "Mail",
    "Mail Test": "Mail Test",
    "Parametre": "Parametre",
    "Port": "Port",
    "Varsayılan Şifre": "Varsayılan Şifre",
    "Yemek Bedeli": "Yemek Bedeli",
    "Kapalı": "Kapalı",
    "E-Posta": "E-Posta",
    "SMS": "SMS",
    "Kullanıcı Tercih Edecek": "Kullanıcı Tercih Edecek",
    "Two Factor Type": "İki Aşamalı Doğrulama Tipi",
    "Seçiniz": "Seçiniz",
    "Yeni Kullanıcı Kaydı Aktif": "Yeni Kullanıcı Kaydı Aktif",
    "Şifremi Unuttum Aktif": "Şifremi Unuttum Aktif",
    "Gizlilik Sözleşmesi Metni": "Gizlilik Sözleşmesi Metni",
    "Kurumsal Bilgiler": "Kurumsal Bilgiler",
    "Firma Kısa Ad": "Firma Kısa Ad",
    "Kuruluş Yılı": "Kuruluş Yılı",
    "Telefon 1": "Telefon 1",
    "Telefon 2": "Telefon 2",
    "Telefon 3": "Telefon 3",
    "E-mail 1": "E-mail 1",
    "E-mail 2": "E-mail 2",
    "E-mail 3": "E-mail 3",
    "Adres": "Adres",
    "Adres Koordinat X": "Adres Koordinat X",
    "Adres Koordinat Y": "Adres Koordinat Y",
    "İletişim Form Mail": "İletişim Form Mail",
    "SEO Bilgileri": "SEO Bilgileri",
    "Site Açıklaması": "Site Açıklaması",
    "Anahtar Kelimeler": "Anahtar Kelimeler",
    "Diğer Ayarlar": "Diğer Ayarlar",
    "Facebook": "Facebook",
    "Twitter (X)": "Twitter (X)",
    "Instagram": "Instagram",
    "Youtube": "Youtube",
    "Pinterest": "Pinterest",
    "Aktif": "Aktif",
    "satis_izin_gun": "Satış İzin Gün",
    "komisyon_vergi": "Komisyon Vergi Oranı",
    "ape_tarih_ay": "APE Tarih Ay",
    "ape_taksit": "APE Taksit Sayısı",
    "ape_peryot": "APE Peryot Ay Sayısı",
    "smape_tip": "SM APE Hesaplama Tipi (0:Satış, 1:Komisyon)",
    "smape_tarih_ay": "SM APE Tarih Ay",
    "smape_taksit": "SM APE Taksit Sayısı",
    "smape_peryot": "SM APE Peryot Ay Sayısı",
    "mesai_0": "Pazar",
    "mesai_1": "Pazartesi",
    "mesai_2": "Salı",
    "mesai_3": "Çarşamba",
    "mesai_4": "Perşembe",
    "mesai_5": "Cuma",
    "mesai_6": "Cumartesi",
    "panel_ayarlari": "Panel Ayarları",
    "mesai_saatleri": "Working Hours",
    "mail_encryption": "Mail Şifreleme (TLS/SSL)",
    "SMS Servis Sağlayıcı": "SMS Servis Sağlayıcı",
    "SMS Başlığı": "SMS Başlığı",
    "Servis Kullanıcı Adı / API Key": "Servis Kullanıcı Adı / API Key",
    "Servis Şifresi / API Secret": "Servis Şifresi / API Secret",
    "Parametre Ayarları": "Parametre Ayarları",
    "Genel Bilgi": "Genel Bilgi",
    "Sosyal Medya": "Sosyal Medya",
    "Mail Ayarları": "Mail Ayarları",
    "2FA Ayarları": "2FA Ayarları",
    "Panel Ayarları": "Panel Ayarları",
    "SMS Ayarları": "SMS Ayarları",
    "Programcı": "Programcı",
    "E-posta 1": "E-posta 1",
    "E-posta 2": "E-posta 2",
    "E-posta 3": "E-posta 3",
    "Mesai Saatleri": "Mesai Saatleri",
    "OrnFirmaAdi": "Örn: FIRMAADI"
  }
}
